export default [
  {
    fullName: 'Наталья Казакова',
    jobTitle: 'Руководитель проектов НОТА Тех,<br>Холдинг Т1',
    photo: require('@/assets/speakers/Kazakova.png')
  },
  {
    fullName: 'Анна Мозер',
    jobTitle: 'Тимлид направления системного анализа в X5Tech,<br>Автор школы системного анализа',
    photo: require('@/assets/speakers/Mozer.jpg')
  },
  {
    fullName: 'Елена Краковская',
    jobTitle: 'Главный аналитик, Дивизион продуктовой разработки,<br>Холдинг Т1',
    photo: require('@/assets/speakers/Краковская.jpg')
  },
  {
    fullName: 'Варвара Ржанникова',
    jobTitle: ' Системный аналитик НОТА, платформа SFERA,<br>Холдинг Т1',
    photo: require('@/assets/speakers/Rzhannikova.jpg')
  },
  {
    fullName: 'Анна Храмцова',
    jobTitle: 'Руководитель направления анализа,<br>Холдинг Т1',
    photo: require('@/assets/speakers/Khramtsova.jpg')
  },
  {
    fullName: 'Наталья Семенова',
    jobTitle: 'Руководитель направления анализа НОТА,<br>Холдинг Т1',
    photo: require('@/assets/speakers/Семенова.png')
  }
]
